const TheContainer = () => import("@/containers/TheContainer.vue")
const AdminPayoutList = () => import('./AdminPayoutList.vue')
const AdminPayoutDetail = () => import('./AdminPayoutDetail.vue')

export default [
  // Admin scope - all payouts
  {
    path: '/admin/payouts',
    component: TheContainer,
    meta: {
      perms: ['admin.payouts.list'],
      breadcrumb: {
        text: 'Admin Payouts',
        to: { name: 'adminPayoutList' }
      }
    },
    redirect: {name: 'adminPayoutList'},
    children: [
      {
        path: '',
        name: 'adminPayoutList',
        component: AdminPayoutList,
      },
      {
        path: ':id',
        name: 'adminPayoutDetail',
        component: AdminPayoutDetail,
        meta: {label: 'Payout Detail'}
      }
    ]
  },
  // Contract Manager scope - filtered payouts
  {
    path: '/contract-manager/:contractManagerId/payouts',
    component: TheContainer,
    meta: {
      perms: ['admin.payouts.list'],
      breadcrumb: (context) => {
        const cm = context.store.getters['contractManager/contract_manager']
        const contractManagerId = context.route.params.contractManagerId

        if (!cm || cm.id !== parseInt(contractManagerId)) {
          context.store.dispatch('contractManager/fetchContractManager', contractManagerId)
            .catch(() => {})
        }

        return [
          { to: { name: 'index' }, text: context.gettext('Dashboard') },
          { to: { name: 'contract_manager.list' }, text: 'Contract Managers' },
          {
            to: { name: 'contract_manager.detail', params: { id: contractManagerId } },
            text: cm && cm.id === parseInt(contractManagerId) ? cm.name : `Contract Manager #${contractManagerId}`
          }
        ]
      },
      breadcrumbMode: 'replace'
    },
    children: [
      {
        path: '',
        name: 'contractManager.payouts',
        component: AdminPayoutList,
        meta: {label: 'Contract Manager Payouts'}
      },
      {
        path: ':id',
        name: 'contractManager.payoutDetail',
        component: AdminPayoutDetail,
        meta: {label: 'Payout Detail'}
      }
    ]
  }
]